import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { eliteIncludes, eliteRows } from '../../data/programa';
export function EliteProtocol() {
  return <section id="elite" className="radial-navy border-b border-line py-[60px] lg:py-[100px]" data-id="element-79" data-mp="3ixlhd831msqf">
      <div className="mx-auto max-w-content px-6 text-center lg:px-10" data-id="element-80" data-mp="3dztexk4rvo7z">
        <SectionHeading eyebrow="Programa Élite" title={<>
              Para cuando la jornada{' '}
              <span className="text-gold" data-id="element-82" data-mp="ail1dch2vaj2">se sale del guion</span>
            </>} data-id="element-81" data-mp="ei24hz917vl2" />

        <Reveal delay={0.06} className="mt-12 text-left" data-id="element-83" data-mp="5q0769u9evf0">
          <div className="glass overflow-hidden" data-id="element-84" data-mp="5ogq4h0s4gc6">
            <div className="hidden grid-cols-[1.1fr_1fr_1.2fr] gap-5 border-b border-line px-5 py-4 lg:grid" data-id="element-85" data-mp="qnm9umy7yf2">
              <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-86" data-mp="y7w1qsuin2wo">
                Situación crítica
              </span>
              <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-87" data-mp="1hlhx8qdl8uty">
                Sin Programa Élite
              </span>
              <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-88" data-mp="1mj9rhr1pgt1b">
                Con Programa Élite
              </span>
            </div>
            <ul className="divide-y divide-line" data-id="element-89" data-mp="1cu9ntuc9d9gs">
              {eliteRows.map(row => <li key={row.situation} className="grid gap-2 px-5 py-3.5 lg:grid-cols-[1.1fr_1fr_1.2fr] lg:gap-5" data-id="element-90" data-mp="1csf3oi8t9ldr">
                  <span className="text-[14px] font-semibold leading-[1.45] text-ice" data-id="element-91" data-mp="13ttpt0eaaujb">
                    {row.situation}
                  </span>
                  <span className="flex gap-2 text-[13px] leading-[1.45] text-cool" data-id="element-92" data-mp="pvwqhw8g4a0y">
                    <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-alert" strokeWidth={2.5} aria-hidden="true" data-id="element-93" data-mp="twozcodeocwp" />
                    {row.without}
                  </span>
                  <span className="flex gap-2 text-[13px] leading-[1.45] text-ice" data-id="element-94" data-mp="2oagge8y2dz26">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={2.5} aria-hidden="true" data-id="element-95" data-mp="1192ph2l4sap" />
                    {row.with}
                  </span>
                </li>)}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.08} className="mt-8 text-left" data-id="element-96" data-mp="3o700rt0cbv7z">
          <div className="glass p-7" data-id="element-97" data-mp="3j7dn5iglocyn">
            <h3 className="text-center text-[12px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-98" data-mp="3j8f8cfrbyfu3">
              El Programa Élite incluye
            </h3>
            <ul className="mt-6 grid gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-99" data-mp="fqneevtmvlt9">
              {eliteIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-100" data-mp="azf3fvcnnsdz">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-101" data-mp="axkiwi5aq2af" />
                  <span className="text-[14px] leading-[1.5] text-cool" data-id="element-102" data-mp="5yhkhgjtmubf">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}